import React from 'react';
import { useTranslation } from 'react-i18next';

export type CurrencyMode = 'EUR' | 'USD' | 'BASE';

interface CurrencySelectorProps {
  selected: CurrencyMode;
  onChange: (mode: CurrencyMode) => void;
}

export function currencySymbol(mode: CurrencyMode): string {
  switch (mode) {
    case 'EUR': return '\u20AC';
    case 'USD': return '$';
    case 'BASE': return '';
  }
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({ selected, onChange }) => {
  const { t } = useTranslation();

  const modes: { value: CurrencyMode; label: string; symbol: string }[] = [
    { value: 'EUR', label: 'EUR', symbol: '\u20AC' },
    { value: 'USD', label: 'USD', symbol: '$' },
    { value: 'BASE', label: t('currencySelector.baseCurrency'), symbol: '' },
  ];

  return (
    <div className="flex items-center gap-1.5">
      <span className="mr-1 text-xs font-medium text-slate-500 dark:text-slate-400">{t('currencySelector.label')}</span>
      {modes.map((m) => (
        <button
          key={m.value}
          onClick={() => onChange(m.value)}
          className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
            selected === m.value
              ? 'bg-accent text-white'
              : 'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700'
          }`}
        >
          {m.symbol ? `${m.symbol} ${m.label}` : m.label}
        </button>
      ))}
    </div>
  );
};
